import {
	AlarmAcknowledgementActions,
	AlarmAcknowledgementResults,
	AlarmAssessmentCode,
	AlarmColorLabel,
	AlarmListResponseObject,
	AlarmModel,
	AlarmNote,
	EventPaginationSetting,
} from './../model/AlarmModel';
import { GridDataColumnItem, ResponseObjectEntity } from './../model/CommonModel';
import { ColumnConfiguration, ProfileSetting } from './../model/ConfigurationModel';
import { Api } from './api';

class AlarmApi extends Api {
	public constructor() {
		super();
	}

	public getStoredAlarms = async (
		paginationSetting: EventPaginationSetting,
		acknowledged: boolean,
		excludeAlarmIds: string[],
		isForAlarmSound: boolean
	): Promise<AlarmListResponseObject> => {
		const url = this.getUrl('Events/RetrieveStoredAlarms', true);
		const data = {
			paginationSetting,
			acknowledged,
			excludeAlarmIds,
			isForAlarmSound,
		};

		return await this.post<AlarmListResponseObject>(url, data);
	};

	public getAlarmsColumnsConfiguration = async (isAcknowledged: boolean): Promise<ResponseObjectEntity<ColumnConfiguration>> => {
		const url = this.getUrl('Events/GetAlarmsColumnsConfiguration', true);
		const data = {
			isAcknowledged,
		};

		return await this.post<ResponseObjectEntity<ColumnConfiguration>>(url, data);
	};

	public getAlarmsTableColumns = async (isAcknowledged: boolean): Promise<ResponseObjectEntity<GridDataColumnItem[]>> => {
		const url = this.getUrl('Events/GetAlarmsTableColumns', true);
		const data = {
			isAcknowledged,
		};

		return await this.post<ResponseObjectEntity<GridDataColumnItem[]>>(url, data);
	};

	public getAlarmAssessmentCodes = async (): Promise<ResponseObjectEntity<AlarmAssessmentCode[]>> => {
		const url = this.getUrl('Events/GetAlarmAssessmentCodes', true);

		return await this.post<ResponseObjectEntity<AlarmAssessmentCode[]>>(url, {});
	};

	public acknowledgeAndClearAlarms = async (
		action: AlarmAcknowledgementActions,
		alarmIds: number[],
		notes: AlarmNote[]
	): Promise<AlarmAcknowledgementResults> => {
		const url = this.getUrl('Events/AcknowledgeAndClearAlarms', true);
		const data = { action, alarmIds, notes };

		return await this.post<AlarmAcknowledgementResults>(url, data);
	};

	public saveAlarmNotes = async (notes: AlarmNote[]): Promise<ResponseObjectEntity<AlarmNote[]>> => {
		const url = this.getUrl('Events/SaveAlarmNotes', true);
		const data = {
			notes,
		};

		return await this.post<ResponseObjectEntity<AlarmNote[]>>(url, data);
	};

	public getAllAlarmIds = async (isAcknowledge: boolean): Promise<ResponseObjectEntity<AlarmModel[]>> => {
		const url = this.getUrl('Events/GetAllAlarmIds', true);
		const data = {
			isAcknowledge,
		};

		return await this.post<ResponseObjectEntity<AlarmModel[]>>(url, data);
	};

	public getAlarmColorLabels = async (): Promise<ResponseObjectEntity<AlarmColorLabel[]>> => {
		const url = this.getUrl('Events/GetAlarmColorLabels', true);

		return await this.post<ResponseObjectEntity<AlarmColorLabel[]>>(url);
	};

	public saveAlarmProperties = async (properties: ProfileSetting[]): Promise<ResponseObjectEntity<boolean>> => {
		const url = this.getUrl('Events/SaveAlarmProperties', true);

		return await this.post<ResponseObjectEntity<boolean>>(url, { properties });
	};
}

const alarmApi = new AlarmApi();

export { alarmApi };
